export function getDealershipByName(dealershipName, dealerships = []) {
  const dealershipsFound = dealerships.filter(dealerhsip => {
    const name = String(dealerhsip.dealershipName).trim();

    return name === String(dealershipName).trim();
  });

  return dealershipsFound[0];
}
